const gtm = require("common/analytics/google-tagmanager");

const ACTION = {
  click: "click",
  focus: "focus",
  blur: "blur"
};

const trackClick = ({ property, label, value }) => {
  gtm.trackEvent({
    category: "gift_card",
    property,
    action: ACTION.click,
    label: label || undefined,
    value: value || undefined
  });
};

const trackFocus = ({ property }) => {
  gtm.trackEvent({
    category: "gift_card",
    property,
    action: ACTION.focus
  });
};

const trackBlur = ({ property, label }) => {
  gtm.trackEvent({
    category: "gift_card",
    property,
    action: ACTION.blur,
    label: label || undefined
  });
};

export const trackBuyYoursNow = () => trackClick({ property: "buy_yours_now_button" });

export const trackFindOutMore = () => trackClick({ property: "find_out_more_button" });

export const trackDeliveryMethodToggle = (label) => trackClick({ property: "delivery_method_toggle", label });

export const trackAmountDropdown = (value) => trackClick({ property: "amount_dropdown", value });

export const trackQuantityField = (value) => trackClick({ property: "quantity_field", value });

export const trackFocusGiftCardMessage = () => trackFocus({ property: "message_field" });

export const trackBlurGiftCardMessage = (message) => {
  const label = message.length > 0 ? "filled" : "empty";
  trackBlur({ property: "message_field", label });
};

export const trackFocusGiftCardEmail = () => trackFocus({ property: "email_field" });

export const trackGiftCardFormContinue = (label) => trackClick({ property: "checkout_button", label });

export const trackGetInTouch = () => trackClick({ property: "get_in_touch_button" });

export const trackContactForm = (redirect) => {
  trackClick({ property: "contact_form_button" });
  redirect();
};

export const trackSendDigitalInstead = () => trackClick({ property: "send_digital_instead_button" });
